import { AxiosResponse } from "axios";
import { API } from "../index";

export interface NoticeImage {
  id?: string;
  asset_url: string;
  asset_key: string;
  sort_order: number;
}

export interface NoticeListItem {
  id: number;
  title: string;
  preview: string;
  display_date: string | null;
  expire_date: string | null;
  is_highlight: boolean;
  is_published: boolean;
  first_image_url: string | null;
  link_urls: Array<{ label: string; url: string }>;
  created_at: string;
}

export interface NoticeDetail {
  id: number;
  title: string;
  content: string;
  display_date: string | null;
  expire_date: string | null;
  link_urls: Array<{ label: string; url: string }>;
  is_highlight: boolean;
  is_published: boolean;
  images: NoticeImage[];
  writer_last4: string;
  created_at: string;
  updated_at: string;
}

export interface NoticePayload {
  site: number;
  title: string;
  content: string;
  display_date?: string | null;
  expire_date?: string | null;
  link_urls: Array<{ label: string; url: string }>;
  is_highlight: boolean;
  is_published: boolean;
  images: Array<{ asset_url: string; asset_key: string; sort_order: number }>;
}

export interface ImageUploadResponse {
  asset_url: string;
  asset_key: string;
}

export const noticeService = {
  getNotices: async (params?: {
    is_published?: boolean;
    is_highlight?: boolean;
  }): Promise<AxiosResponse<{ results: NoticeListItem[] }>> => {
    const queryParams = new URLSearchParams();
    if (params?.is_published !== undefined) {
      queryParams.append("is_published", String(params.is_published));
    }
    if (params?.is_highlight !== undefined) {
      queryParams.append("is_highlight", String(params.is_highlight));
    }
    const query = queryParams.toString();
    return await API.get(`/api/v2/notices/detail/${query ? `?${query}` : ""}`);
  },

  getNotice: async (id: number): Promise<AxiosResponse<NoticeDetail>> => {
    return await API.get(`/api/v2/notices/detail/${id}/`);
  },

  createNotice: async (
    payload: NoticePayload
  ): Promise<AxiosResponse<NoticeDetail>> => {
    return await API.post(`/api/v2/notices/detail/`, payload);
  },

  updateNotice: async (
    id: number,
    payload: NoticePayload
  ): Promise<AxiosResponse<NoticeDetail>> => {
    return await API.put(`/api/v2/notices/detail/${id}/`, payload);
  },

  deleteNotice: async (id: number): Promise<AxiosResponse> => {
    return await API.delete(`/api/v2/notices/detail/${id}/`);
  },

  uploadImage: async (
    file: File
  ): Promise<AxiosResponse<ImageUploadResponse>> => {
    const formData = new FormData();
    formData.append("file", file);
    return await API.post(`/api/v2/notices/detail/upload_image/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};
